/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
    GeoPointToJSONTyped,
} from './GeoPoint';

/**
 * 
 * @export
 * @interface Parish
 */
export interface Parish {
    /**
     * 
     * @type {string}
     * @memberof Parish
     */
    name?: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof Parish
     */
    geo?: GeoPoint;
    /**
     * 
     * @type {number}
     * @memberof Parish
     */
    id?: number;
}

/**
 * Check if a given object implements the Parish interface.
 */
export function instanceOfParish(value: object): value is Parish {
    return true;
}

export function ParishFromJSON(json: any): Parish {
    return ParishFromJSONTyped(json, false);
}

export function ParishFromJSONTyped(json: any, ignoreDiscriminator: boolean): Parish {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'geo': json['geo'] == null ? undefined : GeoPointFromJSON(json['geo']),
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function ParishToJSON(json: any): Parish {
    return ParishToJSONTyped(json, false);
}

export function ParishToJSONTyped(value?: Parish | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'geo': GeoPointToJSON(value['geo']),
        'id': value['id'],
    };
}

